import { render } from "./EditFounderModel.vue?vue&type=template&id=07f8eb23"
import script from "./EditFounderModel.js?vue&type=script&lang=js"
export * from "./EditFounderModel.js?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__